import App from './components/App';

import './app.css';

const LogIn = () => <App />;

export default LogIn;
